import { render } from "./Place.vue?vue&type=template&id=d2081690&scoped=true&ts=true"
import script from "./Place.vue?vue&type=script&lang=ts"
export * from "./Place.vue?vue&type=script&lang=ts"

import "./Place.vue?vue&type=style&index=0&id=d2081690&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2081690"]])

export default __exports__